import type { AddToAppleWalletButtonProps } from '../../types/Card';

export const AddToAppleWalletButton = (_props: AddToAppleWalletButtonProps) => {
    // Add to Apple Wallet is not supported on the web.  The parent component will
    // handle showing the correct UI to the user.
    return null;
};
